export const servicesData = [
  {
    id: 1,
    title: "Web Development",
    description: "Modern, responsive websites built with React, MERN stack, and cutting-edge technologies. Fast, scalable, and user-friendly.",
    icon: "Globe",
    technologies: ["React", "Node.js", "MongoDB", "Express"]
  },
  {
    id: 2,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications that deliver seamless user experiences on iOS and Android.",
    icon: "Smartphone",
    technologies: ["React Native", "Flutter", "iOS", "Android"]
  },
  {
    id: 3,
    title: "Backend & API Development",
    description: "Robust server-side solutions, RESTful APIs, and microservices architecture for scalable applications.",
    icon: "Server",
    technologies: ["Node.js", "Python", "FastAPI", "PostgreSQL"]
  },
  {
    id: 4,
    title: "UI/UX Design",
    description: "Beautiful, intuitive interfaces that enhance user engagement and deliver exceptional digital experiences.",
    icon: "Palette",
    technologies: ["Figma", "Adobe XD", "Tailwind CSS", "Material UI"]
  },
  {
    id: 5,
    title: "Cloud Solutions",
    description: "Cloud infrastructure setup, deployment automation, and DevOps practices for reliable applications.",
    icon: "Cloud",
    technologies: ["AWS", "Azure", "Docker", "Kubernetes"]
  },
  {
    id: 6,
    title: "Maintenance & Support",
    description: "Ongoing support, updates, and optimization to keep your applications running smoothly and securely.",
    icon: "Wrench",
    technologies: ["Monitoring", "Bug Fixes", "Updates", "Security"]
  }
];

export const projectsData = [
  {
    id: 1,
    title: "Zavera Collection",
    businessType: "Premium Clothing Brand",
    description: "A modern e-commerce platform for premium fashion retail with elegant product showcases and seamless shopping experience.",
    images: [
      "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=800&q=80",
      "https://images.unsplash.com/photo-1617019114583-affb34d1b3cd?w=800&q=80",
      "https://images.unsplash.com/photo-1769162151970-02b8a27aaae5?w=800&q=80"
    ],
    liveUrl: "https://zaveras.in/"
  },
  {
    id: 2,
    title: "Fresh Dairy",
    businessType: "Dairy Products Business",
    description: "Complete dairy business platform with online ordering, delivery tracking, subscription management, and customer portal.",
    images: [
      "https://images.unsplash.com/photo-1634141510639-d691d86f47be?w=800&q=80",
      "https://images.unsplash.com/photo-1550583724-b2692b85b150?w=800&q=80",
      "https://images.unsplash.com/photo-1523473827533-2a64d0d36748?w=800&q=80"
    ],
    liveUrl: "#"
  }
];

export const socialLinks = [
  { name: "GitHub", icon: "Github", url: "https://github.com" },
  { name: "LinkedIn", icon: "Linkedin", url: "https://linkedin.com" },
  { name: "Twitter", icon: "Twitter", url: "https://twitter.com" },
  { name: "Instagram", icon: "Instagram", url: "https://instagram.com" }
];

export const contactInfo = {
  email: "yuvidhakad396@gmail.com",
  phone: "+91 9399497650",
  whatsapp: "+91 9399497650",
  address: "Indore, India"
};
